<div class="card" *ngIf="showApplicationDetail">
  <div class="row">
    <div class="mb-3 text-left font-medium text-md">
      <span class="text-primary-700">
        <p-button
          icon="pi pi-arrow-left"
          [rounded]="true"
          [outlined]="true"
          severity="primary"
          [styleClass]="'back-button'"
          (click)="goToBack()"
        ></p-button>
        Revisión de Solicitud
      </span>
      <span class="text-900">
        | {{ member.name }} {{ member.lastName }},
        {{ calculateYearsOld(member.birthDay) }} Años | {{member.club.name}} -> {{transfer.club?.name}}</span
      >
    </div>
    <div class="flex mb-2 gap-2 justify-content-end">
      <p-button
        (click)="activeIndex = 0"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 0"
        label="1"
      ></p-button>
      <p-button
        (click)="activeIndex = 1"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 1"
        label="2"
      ></p-button>
      <p-button
        (click)="activeIndex = 2"
        [rounded]="true"
        styleClass="w-2rem h-2rem p-0"
        [outlined]="activeIndex !== 2"
        label="3"
      ></p-button>
      <p-button
      (click)="activeIndex = 3"
      [rounded]="true"
      styleClass="w-2rem h-2rem p-0"
      [outlined]="activeIndex !== 3"
      label="4"
    ></p-button>
    </div>
  </div>

  <p-tabView [(activeIndex)]="activeIndex">
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-user"></i>
        <span class="ml-1"> Información Personal</span>
      </ng-template>

      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
          class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
        >
          <div class="text-500 w-6 md:w-2 font-medium">Tipo Solicitud</div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
  
            <p-tag
            [severity]="'warn'"
            [rounded]="true"
            [value]="'Transferencia'"
          />

          </div>
        </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Club Actual</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
    
              <div>
                {{ member.club.name}}
              </div>
            </div>
          </li>
                    <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Nuevo Club</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              <div>
                {{ transfer.club!.name}}
              </div>
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">
              Modalidad
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

              <div>
                {{
                  transfer.modalidad
                }}
              </div>
            </div>
          </li>
          <li
          class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
        >
          <div class="text-500 w-6 md:w-2 font-medium">
            Rol
          </div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">

            <div>
              {{
                member.rol
              }}
            </div>
          </div>
        </li>
          <li
          class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
        >
          <div class="text-500 w-6 md:w-2 font-medium">Nivel</div>
          <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
            <p-tag
            [severity]="member.nivel === 'LIGA' ? 'success': 'info'"
            [rounded]="true"
            [value]="member.nivel"
          />
          </div>
        </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Nombre</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ member.name }}
              {{ member.lastName }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Identificación</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ member.idType }}
              {{ member.idNumber }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Género</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{
                member.gender === "M"
                  ? "Masculino"
                  : member.gender === "F"
                  ? "Femenino"
                  : member.gender === "NB"
                  ? "No Binario"
                  : member.gender
              }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">
              Fecha de Nacimiento
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ member.birthDay }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Edad Actual</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ calculateYearsOld(member.birthDay) }} Años
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Teléfono</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ member.contactInformation.telephone }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">Email</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ member.contactInformation.email }}
            </div>
          </li>
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
          >
            <div class="text-500 w-6 md:w-2 font-medium">EPS</div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
              {{ member.assistanceInformation.insurance }}
            </div>
          </li>
        </ul>
      </div>
    </p-tabPanel>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-file"></i>
        <span class="ml-1">Documentos</span>
      </ng-template>
      <div class="surface-section">
        <ul class="list-none p-0 m-0">
          <li
            class="flex align-items-center py-2 px-1 border-bottom-1 surface-border flex-wrap"
            *ngFor="
              let document of transfer.documents.documentsToSend;
              index as i
            "
          >
            <div class="text-500 w-6 md:w-2 font-medium">
              Documento N° {{ i + 1 }}
            </div>
            <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                Carta de Libertad
            </div>
            <div class="w-6 md:w-2 flex justify-content-end">
              <button
                pButton
                pRipple
                label="Ver"
                icon="pi pi-eye"
                class="p-button-text"
                (click)="showPreview(document)"
              ></button>
            </div>
          </li>
        </ul>
      </div>
    </p-tabPanel>
    <p-tabPanel>
      <ng-template pTemplate="header">
        <i class="pi pi-image"></i>
        <span class="ml-1">Foto</span>
      </ng-template>
      <div class="surface-section">
        <div class="flex justify-content-center">
          <img
            [src]="member.picture"
            alt="Foto del solicitante"
            class="applicant-picture"
          />
        </div>
      </div>
    </p-tabPanel>
    <p-tabPanel
      *ngIf="
        transfer.process?.processStage === 'created' ||
        transfer.process?.processStage === 'queued'
      "
    >
      <ng-template pTemplate="header">
        <i class="pi pi-verified"></i>
        <span class="ml-1">Confirmación</span>
      </ng-template>
      <div class="card flex justify-content-center">
        <p-selectButton
          [options]="stateOptions"
          [(ngModel)]="confirmationResponse"
          optionLabel="label"
          optionValue="value"
        ></p-selectButton>
      </div>

      <div *ngIf="confirmationResponse === 'accepted_payment_pending'">
        <p-card
          header="Asignación de productos y servicios"
          class="mt-2"
          subheader="Selecciona los productos y/o servicios que debe pagar el usuario para continuar con la transferencia"
        >
          <div class="row">
            <span class="p-float-label m-2">
              <p-multiSelect
                display="chip"
                [showClear]="true"
                [style]="{ display: 'flex' }"
                [options]="productos"
                [(ngModel)]="productosAsignados"
                optionLabel="name"
                inputId="assignedProductsSelect"
              ></p-multiSelect>
              <label for="">Productos y Servicios *</label>
            </span>
          </div>
          <div class="justify-content-center flex mt-4">
            <p-button
              (click)="sendResponse($event)"
              icon="pi pi-check"
              label="Enviar Respuesta"
              [disabled]="
                productosAsignados.length === 0
              "
            ></p-button>
          </div>
        </p-card>
        <p-toast [baseZIndex]="1200"></p-toast>
        <p-confirmDialog></p-confirmDialog>
      </div>

      <div *ngIf="confirmationResponse === 'rejected'">
        <p-card
          header="Comentarios"
          class="mt-2"
          subheader="Ingrese la descripción del motivo de rechazo de la solicitud"
        >
          <div class="row">
            <span class="p-float-label inline-block m-2">
              <textarea
                rows="5"
                cols="30"
                pInputTextarea
                [(ngModel)]="rejectComments"
              ></textarea>
              <label for="float-label" class="mr-2">Comentarios* </label>
            </span>
          </div>
          <div class="justify-content-center flex mt-2">
            <p-button
              (click)="sendResponse($event)"
              icon="pi pi-check"
              label="Enviar Respuesta"
            ></p-button>
          </div>

          {{ productosAsignados }}
        </p-card>

        <p-toast [baseZIndex]="1200"></p-toast>
        <p-confirmDialog></p-confirmDialog>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
<p-dialog
  *ngIf="showDocumentPreview"
  [header]="documentPreviewSelected.documentName"
  [(visible)]="showDocumentPreview"
  [modal]="true"
  [style]="{ width: '60vw', height: '70vh' }"
  [draggable]="false"
  [resizable]="false"
>
  <iframe
    allowfullscreen
    [src]="documentPreviewSelected.base64"
    [title]="documentPreviewSelected.documentName"
    class="responsive-iframe"
  ></iframe>
</p-dialog>

